import { SequenceManagerAction } from '../actions/SequenceManagerAction';
import { initiateOtp, validateOtp, tccCemBffSendOtp, cemSimSwapValidateOtp, cemSimSwapResendOtp } from '../api/api';

const IDVerificationAction = {
    OTP_INITIATE_SUCCESS : 'OTP_INITIATE_SUCCESS',
    OTP_INITIATE_FAILURE : 'OTP_INITIATE_FAILURE',
    OTP_VALIDATE_SUCCESS : 'OTP_VALIDATE_SUCCESS',
    OTP_VALIDATE_FAILURE : 'OTP_VALIDATE_FAILURE',
    UPDATE_ID_VERIFICATION : 'UPDATE_ID_VERIFICATION',
    ID_VERIFICATION_CEM_OTP_INITIATE_SUCCESS : 'ID_VERIFICATION_CEM_OTP_INITIATE_SUCCESS',
    ID_VERIFICATION_CEM_OTP_VALIDATE_SUCCESS : 'ID_VERIFICATION_CEM_OTP_VALIDATE_SUCCESS',
    ID_VERIFICATION_CEM_OTP_RSEND_SUCCESS : 'ID_VERIFICATION_CEM_OTP_RSEND_SUCCESS',
}

const OTPInitiate = (customerId: any) => {
    return function (dispatch: any) {
        initiateOtp(customerId).then((response) => {
            dispatch({ type: IDVerificationAction.OTP_INITIATE_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: IDVerificationAction.OTP_INITIATE_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }

            })
    }
}

const OTPValidate = (customerId: any, transactionId: any, verificationCode: any) => {
    return function (dispatch: any) {
        validateOtp(customerId, transactionId, verificationCode).then((response) => {
            dispatch({ type: IDVerificationAction.OTP_VALIDATE_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const updateIDVerification = (idNumber: any, nationality: any, orderId: any, nationalityFieldName: any, offerContainerId: any, contactPhone: any, nationalityISOCode: any) => {
    return function (dispatch: any) {
        dispatch({ type: IDVerificationAction.UPDATE_ID_VERIFICATION, payload: { idNumber: idNumber, nationality: nationality, orderId: orderId, nationalityFieldName: nationalityFieldName, offerContainerId: offerContainerId, contactPhone: contactPhone, nationalityISOCode: nationalityISOCode } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['IDVerification'] });
    }
}

const idVerifySendOtp = (number: any, idNumber: any, lang: any, nationality: any) => {
    return function (dispatch: any) {
        tccCemBffSendOtp(number, idNumber, lang, nationality).then((response) => {
            dispatch({ type: IDVerificationAction.ID_VERIFICATION_CEM_OTP_INITIATE_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: IDVerificationAction.ID_VERIFICATION_CEM_OTP_INITIATE_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const idVerifyValidateOtp = (otp: any, refId: any, clientId: any, ClientSecret: any) => {
    return function (dispatch: any) {
        cemSimSwapValidateOtp(otp, refId, clientId, ClientSecret)
            .then((response) => {
                dispatch({ type: IDVerificationAction.ID_VERIFICATION_CEM_OTP_VALIDATE_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'validateLoginOTP' });
                const error = { ...err, config };

                if (error?.response) {
                    dispatch({ type: IDVerificationAction.ID_VERIFICATION_CEM_OTP_VALIDATE_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const idVerifyResendOtp = (refId: any, mode: any) => {
    return function (dispatch: any) {
        cemSimSwapResendOtp(refId, mode)
            .then((response) => {
                dispatch({ type: IDVerificationAction.ID_VERIFICATION_CEM_OTP_RSEND_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'resendCEMOTP' });
                const error = { ...err, config };

                if (error?.response) {
                    dispatch({ type: IDVerificationAction.ID_VERIFICATION_CEM_OTP_RSEND_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}



export { IDVerificationAction, OTPInitiate, OTPValidate, updateIDVerification, idVerifySendOtp, idVerifyValidateOtp, idVerifyResendOtp };